import api from './axiosInstance';

const BASE = '/legal-documents/abandono';

/**
 * Analiza el expediente de una causa.
 *
 * Son DOS canales de subida y la diferencia es jurídica: el ebook es el expediente digital que se
 * baja de la Oficina Judicial Virtual, y los atestados del receptor (embargo, retiro, oposición,
 * requerimiento) el ebook habitualmente NO los incluye. Sin esos atestados la notificación queda
 * en indeterminado y el abandono no se puede declarar procedente.
 *
 * @param {File[]} ebook          PDFs del expediente
 * @param {File[]} receptor       PDFs de los atestados del receptor (opcional)
 * @param {number|null} caseId    Causa, si ya existe en Legal365
 * @param {AbortSignal} signal
 */
export const analizarAbandono = async (ebook, receptor, caseId, signal) => {
  const formData = new FormData();
  (ebook || []).forEach((archivo) => formData.append('ebook', archivo));
  (receptor || []).forEach((archivo) => formData.append('receptor', archivo));
  if (caseId) formData.append('caseId', caseId);

  const response = await api.post(`${BASE}/analizar`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    signal,
  });
  return response.data;
};

/**
 * Recalcula la conclusión sobre el análisis que el abogado corrigió.
 *
 * El cómputo vive en el backend a propósito: es la única fuente de verdad del plazo y no se
 * duplica acá. Cuando el abogado escribe la fecha de notificación, la fuente pasa a
 * `manual_abogado`, que es lo único que permite afirmarla.
 */
export const recalcularAbandono = async (analisis, signal) => {
  const response = await api.post(`${BASE}/recalcular`, analisis, { signal });
  return response.data;
};

/**
 * Genera el escrito de abandono desde el análisis corregido. No llama a la IA: el análisis ya
 * produjo la narrativa de la última gestión útil, así que el escrito sale de una de las 12
 * plantillas y no cuesta tokens.
 */
export const generarEscritoAbandono = async (
  analisis,
  conMandatoJudicial,
  documentoPersoneria,
  caseId,
  confirmado,
  signal
) => {
  const response = await api.post(
    `${BASE}/generar`,
    { analisis, conMandatoJudicial, documentoPersoneria, caseId, confirmado },
    { signal }
  );
  return response.data;
};
